// extracted by css-extract-rspack-plugin
export default {"icon":"icon--wlic3qXvltUGwLSc"};